module.exports = __webpack_public_path__ + "static/media/meeting-link-image.1c6526c3.png";